import axios from '@axios';

const base = '/assistencia-tecnica';
export default {
  lookup: (kind, params) => axios.get(`${base}/opcoes/${kind}`, { params }).then(r => r.data),
  list: params => axios.get(base, { params }).then(r => r.data),
  get: id => axios.get(`${base}/${id}`).then(r => r.data),
  create: data => axios.post(base, data).then(r => r.data),
  update: (id, data) => axios.put(`${base}/${id}`, data).then(r => r.data),
  note: (id, data) => axios.post(`${base}/${id}/notas`, data).then(r => r.data),
  remove: (id, version) => axios.delete(`${base}/${id}`, { data: { version } }).then(r => r.data),
};